import get from 'lodash/get';
import startCase from 'lodash/startCase';

export const hasValue = (record: unknown, source: string): boolean => {
  if (!record || !source) return false;

  const value = get(record, source);

  if (value == null) return false; // covers null + undefined

  if (typeof value === 'string') return value.trim().length > 0;
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === 'object') return Object.keys(value).length > 0;

  return true;
};

/** Display-only formatting for header Applicant Source chip; leaves numeric and mixed IDs unchanged. */
export const formatApplicantSourceBadgeDisplay = (raw: string): string => {
  const v = raw.trim();
  if (!v) return v;
  if (/^[a-z]+(?:_[a-z]+)*$/.test(v)) {
    return startCase(v);
  }
  return v;
};
